import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EProductSortField,
  IProduct,
  PProductFilter,
} from "src/core/product/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IProductState {
  products: IProduct[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IProductState = {
  products: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "product/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "product/FETCH_SUCCEEDED";
const FETCH_FAILED = "product/FETCH_FAILED";
const POLLING_START_REQUESTED = "product/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "product/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IProduct[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PProductFilter;
    pagination: IPagination;
    sorts: ISort<EProductSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IProductState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IProductState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.products = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
